<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/">{{ routeName }}</router-link>
      <button :class="{toggled: $sidebar.showSidebar}"
              aria-controls="navigation-index"
              aria-expanded="false"
              aria-label="Toggle navigation"
              class="navbar-toggler navbar-toggler-right"
              type="button"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <base-dropdown tag="div">
          <template slot="title">
            <span v-if="user">
              <img :src="user.photoURL" class="user-thumb"> {{ user.displayName }}
            </span>
          </template>
          <router-link :to="{path:'/logout'}" class="dropdown-item" href="#">Logout</router-link>
        </base-dropdown>
        <!--        <ul class="nav navbar-nav mr-auto">-->
        <!--          <li class="nav-item">-->
        <!--            <a class="nav-link" data-toggle="dropdown" href="#">-->
        <!--              <i class="nc-icon nc-palette"></i>-->
        <!--            </a>-->
        <!--          </li>-->
        <!--          <base-dropdown tag="li">-->
        <!--            <template slot="title">-->
        <!--              <i class="nc-icon nc-planet"></i>-->
        <!--              <b class="caret"></b>-->
        <!--              <span class="notification">5</span>-->
        <!--            </template>-->
        <!--            <a class="dropdown-item" href="#">Notification 1</a>-->
        <!--            <a class="dropdown-item" href="#">Notification 2</a>-->
        <!--            <a class="dropdown-item" href="#">Notification 3</a>-->
        <!--            <a class="dropdown-item" href="#">Notification 4</a>-->
        <!--            <a class="dropdown-item" href="#">Another notification</a>-->
        <!--          </base-dropdown>-->
        <!--          <li class="nav-item">-->
        <!--            <a class="nav-link" href="#">-->
        <!--              <i class="nc-icon nc-zoom-split"></i>-->
        <!--              <span class="d-lg-block">&nbsp;Search</span>-->
        <!--            </a>-->
        <!--          </li>-->
        <!--        </ul>-->
        <!--        <ul class="navbar-nav ml-auto">-->
        <!--          <li class="nav-item">-->
        <!--            <a class="nav-link" href="#">-->
        <!--              Account-->
        <!--            </a>-->
        <!--          </li>-->
        <!--          <base-dropdown title="Dropdown">-->
        <!--            <a class="dropdown-item" href="#">Action</a>-->
        <!--            <a class="dropdown-item" href="#">Another action</a>-->
        <!--            <a class="dropdown-item" href="#">Something</a>-->
        <!--            <a class="dropdown-item" href="#">Another action</a>-->
        <!--            <a class="dropdown-item" href="#">Something</a>-->
        <!--            <div class="divider"></div>-->
        <!--            <a class="dropdown-item" href="#">Separated link</a>-->
        <!--          </base-dropdown>-->
        <!--          <li class="nav-item">-->
        <!--            <a class="nav-link" href="#">-->
        <!--              Log out-->
        <!--            </a>-->
        <!--          </li>-->
        <!--        </ul>-->
      </div>
    </div>
  </nav>
</template>
<script>
import { firebase } from '../services/FirebaseService';
import { first } from 'rxjs';

export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      user: firebase.auth.currentUser,
    };
  },
  mounted() {
    firebase.user$.pipe(first()).subscribe(() => this.user = firebase.auth.currentUser);
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};

</script>
<style>
.user-thumb {
  height: 24px;
}
</style>
